{
  "TEAMS_SETTINGS": {
    "NEW_TEAM": "Sukurti naują komandą",
    "HEADER": "Komandos",
    "LOADING": "Fetching teams",
    "DESCRIPTION": "Teams allow you to organize agents into groups based on their responsibilities. An agent can belong to multiple teams. When working collaboratively, you can assign conversations to specific teams.",
    "LEARN_MORE": "Learn more about teams",
    "LIST": {
      "404": "Šioje paskyroje nėra sukurtų komandų.",
      "EDIT_TEAM": "Redaguoti komandą",
      "NONE": "Nėra"
    },
    "CREATE_FLOW": {
      "CREATE": {
        "TITLE": "Sukurti naują komandą",
        "DESC": "Pridėkite naujos komandos pavadinimą ir aprašymą."
      },
      "AGENTS": {
        "BUTTON_TEXT": "Pridėti agentus prie komandos",
        "TITLE": "Pridėti agentus prie komandos - {teamName}",
        "DESC": "Į naujai sukurtą komandą įtraukite agentus. Taip galėsite kaip komanda bendradarbiauti pokalbiuose, gauti pranešimus apie naujus įvykius tame pačiame pokalbyje."
      },
      "WIZARD_CREATE": {
        "TITLE": "Sukurti",
        "BODY": "Sukurkite naują agentų komandą."
      },
      "WIZARD_ADD_AGENTS": {
        "TITLE": "Pridėti Agentus",
        "BODY": "Pridėti agentus prie komandos."
      },
      "WIZARD_FINISH": {
        "TITLE": "Pabaigti",
        "BODY": "Esate pasiruošę pradėti!"
      }
    },
    "EDIT_FLOW": {
      "CREATE": {
        "TITLE": "Redaguokite savo komandos duomenis",
        "DESC": "Redaguokite savo komandos pavadinimą ir aprašymą.",
        "BUTTON_TEXT": "Atnaujinti komandą"
      },
      "AGENTS": {
        "BUTTON_TEXT": "Atnaujinkite agentus komandoje",
        "TITLE": "Pridėti agentus prie komandos - {teamName}",
        "DESC": "Pridėkite agentus į savo naujai sukurtą komandą. Visiems pridėtiems agentams bus pranešta, kai pokalbis bus priskirtas šiai komandai."
      },
      "EDIT_WIZARD_DETAILS": {
        "TITLE": "Komandos informacija",
        "ROUTE": "settings_teams_edit",
        "BODY": "Pakeiskite pavadinimą, aprašymą ir kitą informaciją."
      },
      "EDIT_WIZARD_AGENTS": {
        "TITLE": "Keisti Agentus",
        "ROUTE": "settings_teams_edit_members",
        "BODY": "Redaguokite agentus savo komandoje."
      },
      "EDIT_WIZARD_FINISH": {
        "TITLE": "Pabaigti",
        "ROUTE": "settings_teams_edit_finish",
        "BODY": "Esate pasiruošę pradėti!"
      }
    },
    "TEAM_FORM": {
      "ERROR_MESSAGE": "Nepavyko išsaugoti komandos informacijos. Bandyk iš naujo."
    },
    "AGENTS": {
      "AGENT": "Agentas",
      "EMAIL": "El. paštas",
      "BUTTON_TEXT": "Pridėti agentus",
      "ADD_AGENTS": "Agentai pridedami prie komandos...",
      "SELECT": "pasirinkti",
      "SELECT_ALL": "pasirinkti visus agentus",
      "SELECTED_COUNT": "Pasirinkta {selected} iš {total} agentų."
    },
    "ADD": {
      "TITLE": "Pridėti agentus prie komandos - {teamName}",
      "DESC": "Į naujai sukurtą komandą įtraukite agentus. Taip galėsite kaip komanda bendradarbiauti pokalbiuose, gauti pranešimus apie naujus įvykius tame pačiame pokalbyje.",
      "SELECT": "pasirinkti",
      "SELECT_ALL": "pasirinkti visus agentus",
      "SELECTED_COUNT": "Pasirinkta {selected} iš {total} agentų.",
      "BUTTON_TEXT": "Pridėti agentus",
      "AGENT_VALIDATION_ERROR": "Pasirinkite bent vieną agentą."
    },
    "FINISH": {
      "TITLE": "Jūsų komanda yra pasiruošusi!",
      "MESSAGE": "Dabar pokalbiuose galite bendradarbiauti kaip komanda. Gero palaikymo ",
      "BUTTON_TEXT": "Pabaigti"
    },
    "DELETE": {
      "BUTTON_TEXT": "Ištrinti",
      "API": {
        "SUCCESS_MESSAGE": "Komanda ištrinta sėkmingai.",
        "ERROR_MESSAGE": "Nepavyko ištrinti komandos. Bandykite dar kartą."
      },
      "CONFIRM": {
        "TITLE": "Are you sure you want to delete the team?",
        "PLACE_HOLDER": "Įveskite {teamName}, kad patvirtintumėte",
        "MESSAGE": "Ištrynus komandą, komandos priskyrimas bus pašalintas iš šiai komandai priskirtų pokalbių.",
        "YES": "Ištrinti ",
        "NO": "Atšaukti"
      }
    },
    "SETTINGS": "Nustatymai",
    "FORM": {
      "UPDATE": "Atnaujinti komandą",
      "CREATE": "Sukurti komandą",
      "NAME": {
        "LABEL": "Komandos pavadinimas",
        "PLACEHOLDER": "Pavyzdys: pardavimas, klientų aptarnavimas"
      },
      "DESCRIPTION": {
        "LABEL": "Komandos Aprašymas",
        "PLACEHOLDER": "Trumpas šios komandos aprašymas."
      },
      "AUTO_ASSIGN": {
        "LABEL": "Leisti automatiškai priskirti šiai komandai."
      },
      "SUBMIT_CREATE": "Sukurti komandą"
    }
  }
}
